"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Table_1 = tslib_1.__importDefault(require("@mui/material/Table"));
const TableBody_1 = tslib_1.__importDefault(require("@mui/material/TableBody"));
const TableHead_1 = tslib_1.__importDefault(require("@mui/material/TableHead"));
const TableSimpleHeader_1 = tslib_1.__importDefault(require("./TableSimpleHeader"));
const TableSimpleRow_1 = tslib_1.__importDefault(require("./TableSimpleRow"));
const TableSimple = ({ HeadProps, BodyProps, headers, rows, ...rest }) => {
    return (react_1.default.createElement(Table_1.default, { ...rest },
        react_1.default.createElement(TableHead_1.default, { ...HeadProps },
            react_1.default.createElement(TableSimpleHeader_1.default, { ...headers })),
        react_1.default.createElement(TableBody_1.default, { ...BodyProps }, rows?.map((row) => (react_1.default.createElement(TableSimpleRow_1.default, { key: `row-${row?.id}`, ...row }))))));
};
exports.default = TableSimple;
